<div class="d-flex flex-wrap align-items-end justify-content-end justify-content-lg-end">
  <a class="logout" routerLink="connexion" (click)="logout()" data-bs-toggle="tooltip" data-bs-placement="left" title="Déconnexion">Déconnexion <i class="bi bi-box-arrow-right" data-toggle="tooltip" data-placement="bottom"></i></a>
</div>

<div class="sec-title">
  <h1>Modifier un utilisateur</h1>
</div>

<div><a class="btn btn-action" href="/usagers" routerLink="/usagers" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux utilisateurs</a></div>
<div class="alert alert-success p-3"  role="alert" *ngIf="update_message!=''">{{update_message}}</div>
<form class="col-8" [formGroup]="editUserForm" (ngSubmit)="onSubmit(editUserForm.value)" novalidate>
    <fieldset>
      <legend>Formulaire de modification</legend>
      <div class="fieldset-wrap">
        <div class="form-group mb-3">
          <label for="first_name" class="form-label">Prénom</label>
          <input type="text" class="form-control" name="first_name" id="first_name" formControlName="first_name" />
        </div>
    
        <div class="form-group mb-3">
          <label for="last_name" class="form-label">Nom</label>
          <input type="text" class="form-control" name="last_name" id="last_name" formControlName="last_name" />
        </div>

        <div class="form-group mb-3">
          <label for="email" class="form-label">Courriel</label>
          <input type="text" class="form-control" name="email" id="email" formControlName="email" />
        </div>
    
        <!-- <div class="form-group mb-3">
          <label for="role" class="form-label">Roles</label>
          <input type="text" class="form-control" name="role" id="role" formControlName="role" />
        </div> -->

        <div class="form-group mb-3">
          <label for="is_active" class="form-label">Utilisateur actif ?</label>
          <div class="form-group mb-3 me-4 col-sm-12 col-lg-12">
            <select class="form-select" name="active" id="active" formControlName="active">
              <option value="true" [selected]="userInfo.active === true" >Actif</option>
              <option value="false" [selected]="userInfo.active === false" >Non-Actif</option>
            </select>
          </div>
        </div>

        <div class="form-group mb-3">
          <label for="description" class="form-label">Description</label>
          <textarea class="form-control" name="description" id="description" formControlName="description"></textarea>
        </div>
      </div>
    </fieldset>
    <button type="submit" class="btn btn-primary">Enregistrer</button>
    <hr/>
  </form>